import {
  DateRangePicker as AriaDateRangePicker,
  Label,
  Group,
  DateInput,
  DateSegment,
  Button,
  Popover,
  Dialog,
  RangeCalendar,
  CalendarGrid,
  CalendarCell,
  Heading,
} from "react-aria-components";
import { I18nProvider } from "@react-aria/i18n";
import "../../css/DateRangePicker.css";

const renderSegment = (segment) =>
  segment.type === "literal" && segment.text.trim() === "," ? (
    <span className="date-literal-space"> </span>
  ) : (
    <DateSegment segment={segment} />
  );

export function DateRangePicker({ label, value, onChange, locale = "en-NZ", ...props }) {
  return (
    <I18nProvider locale={locale}>
    <AriaDateRangePicker
      {...props}
      value={value}
      onChange={onChange}
    >
      <Label>{label}</Label>
      <Group>
        <DateInput slot="start">{renderSegment}</DateInput>
        <span className="date-range-separator">–</span>
        <DateInput slot="end">{renderSegment}</DateInput>
        <Button aria-label="Open calendar">
          <svg
            height="20"
            width="20"
            viewBox="0 0 20 20"
            aria-hidden="true"
            focusable="false"
            className="date-Svg"
          >
            <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" />
          </svg>
        </Button>
      </Group>

      <Popover>
        <Dialog>
          <RangeCalendar>
            <header>
              <Button slot="previous" aria-label="Previous month">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="m15 18-6-6 6-6" />
                </svg>
              </Button>
              <Heading />
              <Button slot="next" aria-label="Next month">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="m9 18 6-6-6-6" />
                </svg>
              </Button>
            </header>
            <CalendarGrid>
              {(date) => <CalendarCell date={date} />}
            </CalendarGrid>
          </RangeCalendar>
        </Dialog>
      </Popover>
    </AriaDateRangePicker>
    </I18nProvider>
  );
}
